import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { businessInfo } from '../data/businessData';

const { FiPhoneCall } = FiIcons;

export default function CallButton({ className = '', children }) {
  return (
    <motion.a
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      href={`tel:${businessInfo.phone}`}
      className={`inline-flex items-center justify-center gap-2 bg-brand-red text-white px-6 py-3 rounded-full font-semibold shadow-lg hover:bg-red-700 transition-colors duration-300 ${className}`}
    >
      <SafeIcon icon={FiPhoneCall} className="text-xl" />
      {children || "Reserve a pool now"}
    </motion.a>
  );
}